import type Command from "./commandBus/command";
import CommandBus from "./commandBus/commandBus";
import type CommandHandler from "./commandBus/commandHandler";
import InMemoryAsyncCommandBus from "./commandBus/inMemoryAsyncCommandBus";
import type DomainEvent from "./eventBus/domainEvent";
import EventBus from "./eventBus/eventBus";
import type EventSubscriber from "./eventBus/eventSubscriber";
import InMemoryAsyncEventBus from "./eventBus/inMemoryAsyncEventBus";

const commandHandlersMap: Record<string, CommandHandler<Command>> = {};
const eventSubscribersMap: Record<string, EventSubscriber<DomainEvent>[]> = {};

let commandBus: InMemoryAsyncCommandBus;
let localEventBus: InMemoryAsyncEventBus;

//TODO: add the command and events maps received form the BE as arguments
//TODO: initialize in the ps context
function initializeEventDrivenBuses(): void {
  if (!commandBus || !localEventBus) {
    commandBus = new InMemoryAsyncCommandBus(commandHandlersMap);
    localEventBus = new InMemoryAsyncEventBus(eventSubscribersMap);
  }
}

function eventDrivenBusesForMFE() {
  return {
    commandBus,
    localEventBus,
  };
}

export { CommandBus, EventBus, eventDrivenBusesForMFE, initializeEventDrivenBuses };
